import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage-service';
import * as $ from 'jquery';

@Component({
    selector: 'app-customer-auth',
    templateUrl: './supplier-auth.component.html',
    styleUrls: ['./supplier-auth.component.css']
})
export class SupplierAuthComponent implements OnInit {

    public apiInputs = { "project_id": "", "supplier_id": "", "url":"","uid":"","utm_source": "", "utm_medium": "", "utm_term": "", "campaign_id": "","affiliate":0,"tid":"","pid":"","paramsdata":"","router":"","question_arr":""};
    public client: any = '';
    public store: any = '';
    public token: string = '';

    public otpResendTimer: number = 120;
    public otpResendStatus: boolean = false;
    public otpResendInterval: any;
    public otpSendStatus: boolean = false;
    public logoimage='';
    public clientlogo ='';
    public projectid: any = '';
    public supplierid: any = '';
    public url: any = '';
    public uid: any = '';
    public message = "Welcome";
    public utm_source = '';
    public utm_medium = '';
    public utm_term = '';
    public campaign_id= '';
    public uniqueprojectid: any = '';
    public uniquesupplierid: any = '';
    public currentProjectid: any = {};
    public tid: any = '';
    public pid: any = '';
    public paramsData:any='';
    get_question_arr: any = {}

   
    constructor(
        public apiService: ApiService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private localStorageService: LocalStorageService
        
    ) {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
           
            
            if (typeof params.projectid != 'undefined' && params.projectid != '' && params.projectid != null &&
                typeof params.supplierid != 'undefined' && params.supplierid != '' && params.supplierid != null
            ) {
                this.paramsData = params;

                this.get_question_arr = this.paramsData;      
                this.get_question_arr = {...this.get_question_arr};
                delete this.get_question_arr['projectid'];
                delete this.get_question_arr['supplierid'];
                delete this.get_question_arr['url'];
                delete this.get_question_arr['uid'];
                
                this.projectid = params.projectid;
                this.supplierid = params.supplierid;
                this.url = params?.url;
                this.uid = params?.uid;
                this.tid = params?.tid;
                this.pid = params?.pid;
                
                this.apiInputs.paramsdata = this.paramsData;
                this.apiInputs.project_id = this.projectid;
                this.apiInputs.supplier_id = this.supplierid;
                this.apiInputs.url = this.url;
                this.apiInputs.uid = this.uid;
                this.apiInputs.tid = this.tid;
                this.apiInputs.pid = this.pid;
                this.apiInputs.affiliate = params?.affiliate;
                if (typeof params.utm_source != 'undefined' && params.utm_source != '' && params.utm_source != null) {
                    this.apiInputs.utm_source = params.utm_source;
                }
                if (typeof params.utm_medium != 'undefined' && params.utm_medium != '' && params.utm_medium != null) {
                    this.apiInputs.utm_medium = params.utm_medium;
                }
                if (typeof params.utm_term != 'undefined' && params.utm_term != '' && params.utm_term != null) {
                    this.apiInputs.utm_term = params.utm_term;
                }
                if (typeof params.campaign_id != 'undefined' && params.campaign_id != '' && params.campaign_id != null) {
                    this.apiInputs.campaign_id = params.campaign_id;
                }
                if (typeof params.router != 'undefined' && params.router != '' && params.router != null) {
                    this.apiInputs.router = params.router;
                }
                if(this.get_question_arr) {
                    this.apiInputs.question_arr = this.get_question_arr;
                }
            }
            else if ((typeof params.affiliate != 'undefined' && params.affiliate != '' && params.affiliate == 1 && typeof params.campaign_id != 'undefined') || params.campaign_id != '' || params.campaign_id != null) {
                this.paramsData = params;
                this.supplierid = params.supplierid;
                this.url = params?.url;
                this.uid = params?.uid;
                this.tid = params?.tid;
                this.pid = params?.pid;

                this.apiInputs.paramsdata = this.paramsData;
                this.apiInputs.supplier_id = this.supplierid;
                this.apiInputs.url = this.url;
                this.apiInputs.uid = this.uid;
                this.apiInputs.tid = this.tid;
                this.apiInputs.pid = this.pid;
                this.apiInputs.affiliate = params?.affiliate;

                this.apiInputs.utm_source = params.utm_source;
                this.apiInputs.utm_medium = params.utm_medium;
                this.apiInputs.utm_term = params.utm_term;
                this.apiInputs.campaign_id = params.campaign_id;
                if (typeof params.router != 'undefined' && params.router != '' && params.router != null) {
                    this.apiInputs.router = params.router;
                }
            }
            else {
                this.router.navigate(['not-found']);
            }
        });
    }

    ngOnInit(): void {
        const queryParam = { supplierid: this.supplierid, url: this.url, affiliate: this.apiInputs.affiliate, uid: this.apiInputs.uid, campaign_id: this.apiInputs.campaign_id, utm_source: this.apiInputs.utm_source, utm_medium: this.apiInputs.utm_medium, utm_term: this.apiInputs.utm_term }


        if (this.apiInputs.affiliate == 1) {
            // this.router.navigate(['/survey/affiliate-prescreen']);
            this.router.navigate(
                ['survey/affiliate-prescreen'],
                { queryParams: queryParam }
            );
        }
        this.checkurl();
        this.getCustomerProject();
    }
    
     checkurl(){
        this.apiService.postApi(this.apiInputs, 'user/checkProjectData').subscribe((result) => {
            var result = JSON.parse(this.apiService.decode(result.successdata));
            if (result.status == 1) {
                this.uniqueprojectid = result.project_id;
                this.uniquesupplierid = result.supplier_id;
                this.localStorageService.removeItem("project_language");
                this.localStorageService.removeItem("is_default_language");
                if(result.project_language) {
                    this.localStorageService.setItem("project_language", result.project_language);
                    this.localStorageService.setItem("is_default_language", result.is_default_language);
                }
                // this.currentProjectid =  this.localStorageService.getItem("currentProject");
                if(this.currentProjectid != ''){
                    if(this.uniqueprojectid != this.currentProjectid){
                        this.localStorageService.setItem("currentProject", this.uniqueprojectid);
                        this.localStorageService.setItem("uniqueProjectid", '0');
                    }else{
                        this.localStorageService.setItem("uniqueProjectid", '1');
                    }
                }else{
                    this.localStorageService.setItem("currentProject", this.uniqueprojectid);
                    this.localStorageService.setItem("uniqueProjectid", '0');
                }
                
                
                
                decodeURI(result.url);
                window.location = result.url;
            }else{
                this.message = result.message;
            } 

        }, (err) => {

            this.router.navigate(['not-found']);
            //console.log("Client/feedback_list", JSON.stringify(err));
        });
     }

   
     async getCustomerProject() {
        var currentProjectTemp:any = await this.localStorageService.getItem("currentProject");
        this.currentProjectid = JSON.parse(currentProjectTemp);
        
    }
    

    

    

   
}
